export default "__VITE_ASSET__BxcR5FP$__"